/*处理资金流向图数据函数 */

/**
 * 数值规范函数
 * @param {number} data - 需要格式化的数据
 * @returns {number} 返回number类型的数据
 */
function formatData(data) {
  return Number((data / Math.pow(10, 8)).toFixed(2));
}

/**
 * 格式化时间
 * @param {Object} hour 小时
 * @param {Object} minute 分钟
 */
function getTime(hour, minute) {
  let resHour = hour;
  let resMinute = minute;

  if (resHour < 10) {
    resHour = '0' + resHour;
  }

  if (resMinute < 10) {
    resMinute = '0' + minute;
  }

  return String(resHour) + String(resMinute);
}

/**
 * 获取时间列表的数组
 * @param {Object} buySection 净买入开始和结束的时间
 * @param {Object} flowSection 净流入开始和结束的时间
 * @param {bolean} filterSection 过滤的时间区间
 * @returns {number} 返回最小开始时间与最大结束时间中除了午间休市时间的时间字符串数组
 */
function getTimeList(buySection, flowSection, filterSection) {
  // 默认过滤11：30-13：00区间的时间
  let filter = {
    start: '1130',
    end: '1300',
  };
  if (filterSection) {
    filter = {
      ...filter,
      ...filterSection,
    };
  }
  let minStartTime =
    buySection.start <= flowSection.start
      ? buySection.start.split(':')
      : flowSection.start.split(':');
  let maxEndTime =
    buySection.end >= flowSection.end ? buySection.end.split(':') : flowSection.end.split(':');
  const startHour = Number(minStartTime[0]);
  const startMinute = Number(minStartTime[1]);
  const endHour = Number(maxEndTime[0]);
  const endMinute = Number(maxEndTime[1]);
  let startNodataTime = filter.start;
  let endNodataTime = filter.end;
  let resList = [];
  for (let i = startHour; i <= endHour; i++) {
    let jStart = 0;
    if (i === startHour) {
      jStart = startMinute;
    }
    for (let j = jStart; j <= 59; j++) {
      // 休市期间没有数据
      if (getTime(i, j) <= startNodataTime || getTime(i, j) >= endNodataTime) {
        resList.push(getTime(i, j));
      }
      // 到达截止时间直接return
      if (i === endHour && j === endMinute) {
        return resList;
      }
    }
  }
  return resList;
}
/**
 * 获取
 * @param {Object} data 数据为对象数组
 * @param {Arr} section 开始和结束的时间
 * @param {Arr} filedList 要处理成对象数组中子对象的字段的合集
 * @returns {number} 返回图表可以渲染的数组 filedList字段的个数对应数组的长度且顺序一一对应
 */
function getData(data, section, filedList) {
  let timeList = getTimeList(section, section);
  let keyObj = {};
  // 初始化一个key值为时间字符串内容为传入的字段的对象
  for (let i = 0; i < timeList.length; i++) {
    for (let j = 0; j < filedList.length; j++) {
      if (!keyObj[timeList[i]]) {
        keyObj[timeList[i]] = {};
      }
      keyObj[timeList[i]][filedList[j]] = undefined;
    }
  }

  // 将数据赋值给该对象，没有数据的key值内容都是undefined
  data.forEach(function (item) {
    const time = item.time.replace(':', '');
    let total = 0;
    filedList.forEach(function (it) {
      if (it === 'total') {
        keyObj[time][it] = total;
      } else {
        total += formatData(item[it]);
        keyObj[time][it] = formatData(item[it]);
      }
    });
  });
  let resData = [];
  // 将时间字符串key对应的对象的多个内容放入一个二维数组不同的子数组中，相同内容放入一个子数组
  for (let i = 0; i < timeList.length; i++) {
    for (let j = 0; j < filedList.length; j++) {
      if (!resData[j]) {
        resData[j] = [];
      }
      resData[j].push(keyObj[timeList[i]][filedList[j]]);
    }
  }
  return resData;
}

/**
 * 获取
 * @param {Object} data 资金流向图买入和流向数据
 * @param {Arr} buySection 买入开始和结束时间
 * @param {Arr} flowSection 流入开始和结束时间
 * @returns {number} 返回买入和卖出图表渲染需要的数据
 */
function getCaptialFlowChartData(data, buySection, flowSection) {
  const filedList = ['sh', 'sz', 'total'];
  const data_buy = getData(data.net_buy, buySection, filedList);
  const data_flow = getData(data.net_inflow, flowSection, filedList);
  // data_buy data_flow为二维数组 长度filedList包含字段的格式
  return {
    h_buy: data_buy[0] || [],
    s_buy: data_buy[1] || [],
    total_buy: data_buy[2] || [],
    h: data_flow[0] || [],
    s: data_flow[1] || [],
    total: data_flow[2] || [],
  };
}

/**
 * 获取指定时间的秒级时间戳
 */
function getSpecificTimeTimestampInSeconds(timestamp,hours, minutes) {
  // 创建一个日期的对象
  const date = new Date(timestamp);

  // 设置时间为指定的小时和分钟
  date.setHours(hours, minutes, 0, 0); // 将时间设置为指定的小时和分钟，秒和毫秒都设为 0

  // 获取指定时间的时间戳（毫秒级）
  const specificTimeTimestampInMillis = date.getTime();

  // 将毫秒级时间戳转换为秒级时间戳
  const specificTimeTimestampInSeconds = Math.floor(specificTimeTimestampInMillis / 1000);

  return specificTimeTimestampInSeconds;
}

/**
 * 获取指定前N天零时的秒级时间戳
 */
function getForwardNDayTimestampInSeconds(n) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const timestampInMillis = today.getTime();
  //前N天零时毫秒级时间戳
  const forwardNDayTimestampInMillis = timestampInMillis - Number(n) * 24 * 60 * 60 * 1000;
  const res = Math.floor(forwardNDayTimestampInMillis / 1000);
  return res;
}

/**
 * 根据秒级时间戳格式化日期
 */
function formateDateByTimestampInSeconds(val, separator = '-') {
  const formate = value => {
    if (Number(value) < 10) {
      return '0' + value;
    }
    return value;
  };
  const date = new Date(Number(val) * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const res = [year, formate(month), formate(day)];
  return res.join(separator);
}

//陆股通主力资金和指数信息数组
const indexInfoArr = [
  {
    name: 'lgtmm', //陆股通主力资金
    code: '48:883957',
  },
  {
    name: 'hgtmm', //沪股通主力资金
    code: '16:1A0001',
  },
  {
    name: 'sgtmm', //深股通主力资金
    code: '32:399001',
  },
];

/**
 * 处理陆股通主力净流入数据
 */
function handleHsgtMainMoneyData(data) {
  const res = {};
  indexInfoArr.forEach(item => {
    const indexData = data.find(val => val.code === item.code);
    if (indexData) {
      const arr = [];
      indexData.values[0]['values'].forEach(value => {
        //将每一时刻的值亿元化
        const result = formatData(value);
        arr.push(result);
      });
      res[item.name] = arr;
    }
  });
  return res;
}

/**
 * 解析日期字符串转换成毫秒级时间戳
 */
function getSpecificTimeTimestampInMillisByDateStr(dateStr) {
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);
  const date = new Date(year, month - 1, day);
  const timestampInMillis = date.getTime();
  return timestampInMillis;
}

export {
  getCaptialFlowChartData,
  getTimeList,
  getSpecificTimeTimestampInSeconds,
  getForwardNDayTimestampInSeconds,
  formateDateByTimestampInSeconds,
  handleHsgtMainMoneyData,
  getSpecificTimeTimestampInMillisByDateStr
};
